export const getFieldMessages = state =>
  (state.error && state.error.detail ? state.error.detail.fieldMessages : null)



/** WEBPACK FOOTER **
 ** ./src/selectors/error/error.js
 **/